import { styled } from "@mui/material/styles";

export const StyledHr = styled("hr")(({ theme }) => ({
  border: 0,
  borderTop: `1px solid ${theme.palette.divider}`,
  margin: theme.spacing(2, 0),
  opacity: 0.8,
}));
